/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_All_A_To_B_TitleInputs */



/**
* | output |
* | --- |
* | "Apply all compared changes from Group A to Group B" |
*
* @param {Compare_Event_Groups_Apply_All_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_all_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Apply_All_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_All_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer toutes les variations comparées du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übertragen Sie alle verglichenen Änderungen von Gruppe A auf Gruppe B.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare tutte le modifiche confrontate dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примените все сравнительные изменения из группы А к группе В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar todos los cambios comparados del Grupo A al Grupo B.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将A组的所有比较变化应用到B组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAからグループBへ比較対象となるすべての変更を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A से समूह B पर तुलना किए गए सभी परिवर्तनों को लागू करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar todas as alterações comparadas do Grupo A ao Grupo B.")
	return /** @type {LocalizedString} */ ("Apply all compared changes from Group A to Group B")
});